import { chapters } from '@/mocks/data';
import { useNavigate } from 'react-router-dom';

export default function LatestUpdates() {
  const navigate = useNavigate();
  const latestChapters = chapters.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最新更新</h2>
            <p className="text-sm text-foreground-500 mt-1">终末的女武神最新章节</p>
          </div>
          <a
            href="/category"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            全部章节 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
          {latestChapters.map((chapter, index) => (
            <div
              key={chapter.id}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100/70 transition-colors ${
                index < latestChapters.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
              onClick={() => navigate(`/article/${chapter.comicId}?chapter=${chapter.id}`)}
            >
              <span className="w-8 h-8 rounded-full bg-primary-100 text-primary-600 font-medium text-xs flex items-center justify-center shrink-0">
                {chapter.number}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 hover:text-primary-500 transition-colors truncate">
                  {chapter.title}
                </h3>
              </div>
              <div className="hidden sm:flex items-center gap-4 text-xs text-foreground-500 shrink-0">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  {chapter.views}
                </span>
              </div>
              <div className="text-xs text-foreground-400 shrink-0 whitespace-nowrap">{chapter.updateTime}</div>
              <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center shrink-0"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}